// Endpoints that must never raise the global loader, keyed
// `${reducerPath}/${endpointName}`. The RTK Query counterpart of
// ./non-loader-actions, which does the same job for async-ops operation names.
//
// Add an endpoint here when the component already renders its own inline
// indicator for that request, or when the request is background work the user
// did not ask for and should not be blocked by.
export const rtkQueryNonLoaderEndpoints = {
  "riskAreasApi/getBillingSectionRows": true,
  "riskAreasApi/getProviderSectionRows": true,
  "riskAreasApi/getCoderSectionRows": true,
  "riskAreasApi/getAuditInfoSnapshot": true,
  "riskAreasApi/bulkUpdateRiskAreas": true,
  "riskAreasApi/getRiskAreaDetails": true,
};
